import { Loader } from "@/assets/icon/loader";

const PageLoading = () => {
  return (
    <div className="text-black/50 flex items-center justify-center flex-1">
      <Loader />
    </div>
  );
};

export default PageLoading;
